/*
 * 解析url 获取基本信息
 * @param path
 * @return  promise对象
 */
export function parsePath(path) {
  const queryStr = path.slice(path.indexOf('?') + 1)
  const vars = queryStr.split('&')
  const query = {}
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=')
    query[pair[0]] = pair[1]
  }
  console.log(query)
  return { query }
}



// WEBPACK FOOTER //
// ./src/utils/parse.js